import {Origine,Visibilite} from "@domain/geolocalisation/localisation";
import {LieuParam} from "@domain/common/lieu/lieu-param";

/**
 * Paramétrage pour la partie admin du lieu
 */
export class LieuParamAdmin extends LieuParam {
    /** {@inheritDoc} */
    urlAdresse = `/controller/Adresse/searchAdresse`;

    /** {@inheritDoc} */
    titleAdresseTab = "lieu.tabs.adresses";

    /** {@inheritDoc} */
    listeVisibiliteLocalisation = [Visibilite.FILTRE_V_ADM];

    /** {@inheritDoc} */
    origineLocalisation = Origine.ORIGINE_ADMIN;

    /** {@inheritDoc} */
    idUser = 0;

    /** {@inheritDoc} */
    isSaisieAutorisee = () => true;

    /** {@inheritDoc} */
    placeHolder = (libelleAdresse: String,isDisabled: boolean) => {
        return libelleAdresse
            ? ''
            : isDisabled
                ? 'lieu.aucuneSelection'
                : 'profilUser.adresses.add.selection';
    };

    /** {@inheritDoc} */
    isShowAdresseFiltre = true;

    /** {@inheritDoc} */
    isShowProPersoAdresseFiltre = true;

    /** {@inheritDoc} */
    isFormatRueFromLocalisation = true;

    /** {@inheritDoc} */
    isRueRequired = true;
}